import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import {config} from "./config.tsx";
import {openEdit} from "./edit.tsx";
import {tableApiFunc} from "@/utils/data.ts";
import {deleteMemberLevel, queryMemberLevelListByPage} from "@/services/member.ts";
import {message} from "antd";
import {useRef} from "react";

/**
 *
 * 会员等级
 * @constructor
 */
function Page() {

    const tableRef = useRef<any>()

    const onDelete = (id: string) => {
        deleteMemberLevel({id}).then(() => {
            message.success('删除成功');
            tableRef.current.reload();
        })
    }

    const onAddOrEdit = (data?: any) => {
        openEdit({
            title: '会员等级',
            data,
            destroy: (success) => {
                if (success) {
                    tableRef.current.reload();
                }
            }
        });
    }
    const getStatusOptions = async () => {
        return Promise.resolve({})
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberLevelListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
            getStatusOptions,
        },
        events: {onAdd: () => onAddOrEdit()},
        customRender: {
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
                        {!record.status && <SActionBtn isDelete onClick={() => onDelete(record.id)}>删除</SActionBtn>}
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    ref={tableRef}
                    {...extensions}
                />
            </div>
        </div>
    );
}

export default Page;
